import { Autocomplete, TextField } from '@mui/material';
import { usePricePoints } from '../create-price-queries';

type RrpPricePointsDropdownProps = {
  priceUnitId: number;
  planningYear: number;
  rrp: number;
  displayValue: string;
  onSelect: (selectedItem: string) => void;
  onClose?: () => void;
  pendingEditKey?: string | null;
};

const RrpPricePointsDropdown = ({
  priceUnitId,
  planningYear,
  rrp,
  displayValue,
  onSelect,
  onClose,
  pendingEditKey,
}: RrpPricePointsDropdownProps) => {
  const { data, isFetching } = usePricePoints(priceUnitId, planningYear, rrp);

  return (
    <Autocomplete
      openOnFocus
      options={(
        data?.below?.map((item) => item.localRecommendedRetailPricePoint) ?? []
      )
        .concat(
          data?.above?.map((item) => item.localRecommendedRetailPricePoint) ??
            [],
        )
        .filter((x) => x !== undefined)
        .sort((a, b) => a - b)}
      value={pendingEditKey ?? displayValue}
      loading={isFetching}
      onChange={(_, newValue) => {
        if (newValue !== undefined && newValue !== null) {
          onSelect(newValue.toString());
        }
      }}
      onClose={onClose}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="standard"
          autoFocus
          size="small"
          sx={{ fontSize: '11px' }}
          onBlur={(e) => {
            const value = e.target.value;
            if (value !== undefined && value !== null && value !== '') {
              onSelect(value);
            }
            onClose?.();
          }}
          slotProps={{
            ...params.slotProps,
            input: {
              ...params.slotProps.input,
              onFocus: (e) => {
                // highlight if no number key was pressed
                if (pendingEditKey === null || pendingEditKey === undefined) {
                  e.target.select();
                }
              },
              sx: { fontSize: '11px' },
            },
          }}
        />
      )}
      slotProps={{
        listbox: {
          sx: { fontSize: '11px' },
        },
        popper: {
          sx: { width: 'auto !important', minWidth: 80 },
          placement: 'bottom-start',
        },
      }}
      fullWidth
      freeSolo
    />
  );
};
export default RrpPricePointsDropdown;
